// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"368":"1860ec50","445":"bcfbc7d0","624":"e8c8ee29","738":"dc26d8e5"}[chunkId] + ".css";
};